<template>
    <div v-if="openSubscribeModal" class="blog-subscribe-form">
        <div class="ltd-guide-modal d-flex flex-column justify-content-ceter align-items-center">
            <div class="d-flex flex-column justify-content-ceter align-items-center">
                <img src="/img/home-v2/fomo-modal-exit.svg" class="exit-modal" alt="close icon" @click="openSubscribeModal = false">
                <img src="/img/blog/banners/subscribe-icon.svg" alt="infinity blog subscribe">
                <h4 v-if="!formSubmitted" class="text-center mt-4">Subscribe to Our <br> Newsletter</h4>
                <h4 v-if="formSubmitted" class="text-center mt-4" style="font-size: 26px;">Thank you for subscribing to our newsletter!</h4>
                <p v-if="!formSubmitted" class="text-center" style="font-size: 16px;">Get the latest posts and Infinity updates delivered straight to your inbox.</p>
                <form v-if="!formSubmitted" @submit="checkForm">
                    <div class="input-wrapper mb-3">
                        <input type="text" v-model="name" required placeholder="Name" id="name-sub">
                        <div class="input-error" v-if="errorName" v-text="errorName"></div>
                    </div>
                    <div class="input-wrapper mb-3">
                        <input type="email" v-model="email" required placeholder="Email" class="subscribe-email" id="email-sub">
                        <div class="input-error" v-if="errorEmail" v-text="errorEmail"></div>
                    </div>
                    <button 
                        type="submit" 
                        class="cta-btn-v2 mt-4 mb-0 justify-content-center sub-submit mx-auto"
                        data-ce 
                        data-ce-category="Blog Subscribe" 
                        data-ce-action="Blog Subscribe"
                        data-ce-label="button" 
                        data-ce-value="Subscribe" 
                    >
                        Subscribe
                    </button>
                </form>
            </div>
        </div>
        <div id="popup-overlay" @click="openSubscribeModal = false"></div>
    </div>
</template>
<style lang="less" scoped>

.blog-subscribe-form {
    #popup-overlay {
        display: block;
    }
}
.exit-modal {
    position: absolute;
    right: 10px; 
    top: 10px;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
}
.ltd-guide-modal {
    background-image: url('/img/blog/banners/subscribe-modal-bg.png');
    background-size: cover;
    background-position: top;
    border-radius: 7px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 101;
    padding: 37px;
    padding-top: 27px;
    background-color: #1A213A;
    color: #fff;
    width: 380px;
    max-width: 95%;
    max-height: 90vh;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
        border-radius: 10px;
        width: 5px;
        background-color: #1A213A;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: rgba(255, 255, 255, 0.5);
    }
    p {
        font-weight: 600;
        font-size: 20px;
        line-height: 27px;
    }
    h4 {
        font-weight: 600;
        font-size: 28px;
        line-height: 38px;
    }
    input {
        background-color: #13192F !important;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 5px;
        box-sizing: border-box;
        font-size: 18px;
        line-height: 25px;
        width:100%;
        height: 50px;
        padding-left:18px;
		color: rgba(255, 255, 255, 0.4);
        &:active, &:focus {
            background-color: #13192F;
            border: 1px solid rgba(255, 255, 255, 0.2);
            color: rgba(255, 255, 255, 0.4);
        }
        @media (max-width: 768px) {
            height: 40px;
        }
    }
    button{
        outline: none;
        border: none;
        background-color: #C02B95;
        border-radius: 3.75121px;
        height: 50px;
        width: 180px;
    }
    form {
        width: 100%;
    }
}
.formSubmittedModal {
    background: none;
    padding: 0;
}
</style>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            openSubscribeModal: false,
            errorName: null,
            errorEmail: null,
            name: '',
            email: '',
            formSubmitted: false
        }; 
    },
    mounted() {
        var vm = this;
        setTimeout(function () {
            document.addEventListener('mouseout', function(evt) {
                let triggerChecker = document.cookie.indexOf('subscribeModalTriggered') > -1;
                if(evt.toElement === null && evt.relatedTarget === null && !triggerChecker) {
                    // An intent to exit has happened
                    vm.openSubscribeModal = true;
                    document.cookie = 'subscribeModalTriggered = true';
                }
            });
        }, 10);

        if (window.innerWidth < 768 && document.cookie.indexOf('subscribeModalTriggered') == -1) {
            setTimeout(function () {
                this.openSubscribeModal = true;
                document.cookie = 'subscribeModalTriggered = true';
            }, 5000);
        }
    },
    methods: {
        checkForm: function (e) {
            e.preventDefault();

            if (this.name && this.age) {
                return true;
            }

            this.errorName = null;
            this.errorEmail = null;

            if (!this.name) {
                this.errorName = 'Name required.';
            }
            if (this.name && this.name.length < 3) {
                this.errorName = 'Name must be at least 2 character.';
            }

            if (!this.email) {
                this.errorEmail = 'Email required.';
            }

            if(this.errorName == null && this.errorEmail == null){
                window.Intercom('boot', {
                    app_id: 'ujmidnoy',
                    email: this.email,
                    name: this.name,
                    blog_subscribe: true, // custom attribute ( property )
                    user_id: this.email ,
                    created_at:  Math.round((new Date()).getTime() / 1000),
                });

                // push tag to google tag manager
                dataLayer.push({'event': 'blog_subscribe'});

                axios.put('/api/analytics', {
                    'name': 'blog_subscribe',
                });

                // add to cookie
                this.$cookies.set('blog_subscribe', true ,60 * 60 * 24 * 30* 12 );
                this.$cookies.set('email', this.email ,60 * 60 * 24 * 30* 12 );
                this.$cookies.set('name', this.name ,60 * 60 * 24 * 30* 12 );
                this.submited = true;
                this.formSubmitted = true;
            }
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/BlogSubscribeForm.vue